/**
 * Function that returns proper query params mark for request url
 * @param {string} url - request url
 */
export const addQueryParamMark = (url) => {
	return !/\?/i.test(url) ? '?' : '&';
};
